module.exports = __webpack_public_path__ + "static/media/frflag.e59c82fc.svg";